import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import closeIconPath from '../../assets/icons/x-close-mobile-icon.svg';
import './cookies.scss';

const COOKIE_NAME = 'hot_ins_cookies_accepted';
const HOT_WEBSITE_URL = 'https://www.hot.co.il/';
const DEFAULT_POLICY_PAGE = 'מדיניות-פרטיות';

const COOKIES_MESSAGE =
    'באתר זה משתמשים בקבצי עוגיות לשם שיפור חווית השימוש שאנו מספקים לך ולצרכים שיווקים. ' +
    'המשך גלישתך מעידה על נכונותך לשימוש בקבצים אלו בהתאם ל';

const COOKIES_PRIVACY_LINK_TEXT = 'מדיניות פרטיות';

export function getCookie(name) {
    const decodedCookie = decodeURIComponent(document.cookie);
    for (const part of decodedCookie.split(';')) {
        const cookie = part.trim();
        if (cookie.startsWith(`${name}=`)) {
            return cookie.substring(name.length + 1);
        }
    }
    return '';
}

function setCookieAccepted() {
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie =
        `${COOKIE_NAME}=true; expires=${expiry.toUTCString()}; ` +
        `domain=${window.location.hostname}; path=/;`;
}

const Cookies = () => {
    const gd = useSelector((store) => store.gd);
    const policyPage = gd?.Privacy_url || gd?.PrivacyPage?.Privacy_url || DEFAULT_POLICY_PAGE;
    const [, setAccepted] = useState(getCookie(COOKIE_NAME) === 'true');

    const showBanner = getCookie(COOKIE_NAME) !== 'true';

    const handleAccept = useCallback(() => {
        setCookieAccepted();
        setAccepted(true);
    }, []);

    if (!showBanner) {
        return null;
    }

    const privacyHref = `${HOT_WEBSITE_URL}מדיניות_פרטיות`;

    return (
        <div className="cookies_container">
            <div className="cookies_layer">
                <div className="cookies_content">
                    <p className="msg">
                        {COOKIES_MESSAGE}
                        <a href={privacyHref} className="privacy-link">
                            {COOKIES_PRIVACY_LINK_TEXT}
                        </a>
                    </p>
                    <div className="accept">
                        <button
                            type="button"
                            style={{ width: '100%', cursor: 'pointer' }}
                            onClick={handleAccept}
                            aria-label="קבל שימוש בעוגיות"
                        >
                            <img src={closeIconPath} alt="" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cookies;
